module.exports = __webpack_public_path__ + "img/5.04e3b7d2.jpg";